import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  editingRecords: {}
};

const isEditingSlice = createSlice({
  name: 'isEditing',
  initialState,
  reducers: {
    startEditing: (state, action) => {
      const { recordId, recordType, messageId, type = 'update' } = action.payload;
      const key = `${messageId}_${recordId}`;
      state.editingRecords[key] = { recordId, recordType, messageId, isEditing: true, type };
    },
    stopEditing: (state, action) => {
      const { recordId, messageId } = action.payload;
      const key = `${messageId}_${recordId}`;
      delete state.editingRecords[key];
    },
    clearAllEditing: (state) => {
      state.editingRecords = {};
    },
    // New reducer to clear all editing records by messageId
    clearEditingByMessageId: (state, action) => {
      const { messageId } = action.payload;
      Object.keys(state.editingRecords).forEach((key) => {
        if (key.startsWith(`${messageId}_`)) {
          delete state.editingRecords[key];
        }
      });
    },
  },
});

export const {
  startEditing,
  stopEditing,
  clearAllEditing,
  clearEditingByMessageId,
} = isEditingSlice.actions;
export default isEditingSlice.reducer;